export default __webpack_public_path__ + "static/who-we-are-5cc465168be6a11afff5c81973e301df.webp";